import { render, staticRenderFns } from "./SkillsPerson.vue?vue&type=template&id=26c841a2"
import script from "./SkillsPerson.vue?vue&type=script&lang=js"
export * from "./SkillsPerson.vue?vue&type=script&lang=js"
import style0 from "./SkillsPerson.vue?vue&type=style&index=0&id=26c841a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports